module.exports = __webpack_public_path__ + "static/img/5en.f26f919.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/5en.png
// module id = ubDX
// module chunks = 0